import React, { useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { FieldWrapper } from '@progress/kendo-react-form';
import { Error, Hint } from '@progress/kendo-react-labels';
import LabelPure from '../../../pures/label/label.pure';
import './bot-template-dropdown-wrapper.css';

function BotTemplateDropdownWrapper(fieldRenderProps) {
    const {
        touched,
        label,
        id,
        valid,
        hint,
        validationMessage,
        data = [],
        placeholder,
        value,
        onChange,
        onBeforeChange,
        ...others
    } = fieldRenderProps;

    const editorRef = useRef(null);
    const [hoverTooltip, setHoverTooltip] = useState(null);
    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : "";
    const errorId = showValidationMessage ? `${id}_error` : "";
    const labelId = label ? `${id}_label` : "";
    const selectedItem = data.find(item => item.id === value) || null;

    const handleItemMouseEnter = (e, description) => {
        if (!description) return;
        const rect = e.currentTarget.getBoundingClientRect();
        setHoverTooltip({
            text: description,
            top: rect.top,
            left: rect.right + 8
        });
    };

    const handleItemMouseLeave = () => {
        setHoverTooltip(null);
    };

    const handleChange = (e) => {
        const newId = e.value?.id ?? null;
        const applyChange = () => onChange({ value: newId });

        if (onBeforeChange) {
            onBeforeChange(newId, value, applyChange);
        } else {
            applyChange();
        }
    };

    const templateItemRender = (li, itemProps) => {
        return React.cloneElement(li, {
            ...li.props,
            onMouseEnter: (e) => handleItemMouseEnter(e, itemProps.dataItem.description),
            onMouseLeave: handleItemMouseLeave
        });
    };

    return (
        <FieldWrapper className={`botTemplateDropdownWrapper ${showValidationMessage ? "botTemplateDropdownWrapper-error" : ""}`}>
            <LabelPure
                id={labelId}
                editorId={id}
                className="k-form-label"
                title={label}
            />
            <div className={"k-form-field-wrap"}>
                <DropDownList
                    ariaLabelledBy={labelId}
                    ariaDescribedBy={`${hintId} ${errorId}`}
                    ref={editorRef}
                    id={id}
                    className="eticket-dropdown-field"
                    fillMode="flat"
                    rounded={false}
                    data={data}
                    textField="name"
                    dataItemKey="id"
                    defaultItem={{ id: null, name: placeholder }}
                    value={selectedItem}
                    onChange={handleChange}
                    itemRender={templateItemRender}
                    validationMessage={validationMessage}
                    {...others}
                    valid={!showValidationMessage}
                />
                {showHint && <Hint id={hintId}>{hint}</Hint>}
                {showValidationMessage && (
                    <Error id={errorId}>{validationMessage}</Error>
                )}
            </div>
            {hoverTooltip && createPortal(
                <div
                    className="bot-template-item-tooltip"
                    style={{ top: hoverTooltip.top, left: hoverTooltip.left }}
                >
                    {hoverTooltip.text}
                </div>,
                document.body
            )}
        </FieldWrapper>
    )
};

export default BotTemplateDropdownWrapper
